export default __webpack_public_path__ + "static/media/e-commerce.c75528f6.png";